import { Component, Input, OnInit } from '@angular/core';
import { getDateDiff, getDurationString, getPhaseCompleted, getPhaseSpent, getPhaseStart } from 'src/app/shared/helpers/utils';
import { PhaseEstimatedDurations } from '@shared/enums/phase-estimated-durations.enum';
import { PhasesNames } from '@shared/enums/phases-names.enum';

@Component({
  selector: 'app-case-benefit',
  templateUrl: './benefit.component.html',
  styleUrls: ['../../../timeline/timeline.component.scss', './benefit.component.scss'],
})
export class BenefitCaseComponent implements OnInit {
  @Input() case;

  isDisabled = true;
  started = '';
  completed = '';
  timeInPhase = '';
  leftHours = '';
  showEdit = false;

  constructor() {
  }

  ngOnInit(): void {
    const phaseTasks = this.case?.tasks?.filter(x => x.phase === PhasesNames.benefitsVerification);
    this.started = getPhaseStart(phaseTasks);
    this.completed = getPhaseCompleted(phaseTasks);
    if (this.completed) {
      const spent = getPhaseSpent(phaseTasks);
      this.timeInPhase = getDurationString(spent > 0 ? spent : 0, 'hours', 'd [days] h [hours]', {trim: 'both'});
      const leftToEdit = PhaseEstimatedDurations.benefitsVerification - getDateDiff(new Date(), this.completed, 'hours', true);
      this.showEdit = leftToEdit > 0;
      this.leftHours = getDurationString(leftToEdit > 0 ? leftToEdit : 0, 'hours', 'h [hrs] m [min]', {trim: 'both', usePlural: false});
    }
  }

  toggleDisabled(): void {
    this.isDisabled = !this.isDisabled;
  }

  getSpent(tasks): number {
    const reducer = (accumulator, currentValue) => {
      const first = currentValue.createDate;
      const second = currentValue.completed || new Date();
      const diff = getDateDiff(second, first, 'hours', true);
      return accumulator + diff;
    };

    return tasks.reduce(reducer, 0);
  }
}
